module.exports = __webpack_public_path__ + "img/About.a95dbcd9.png";